import { Component } from '@angular/core';
import { CommonService } from '../common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-contact-rishi-dialog',
  templateUrl: './contact-rishi-dialog.component.html',
  styleUrls: ['./contact-rishi-dialog.component.scss']  // MUST match
})
export class ContactRishiDialogComponent {

  form: FormGroup;

  item : any;
  error: string | undefined;
  message: string | undefined;
  disabled: boolean | undefined;

  constructor(public cs: CommonService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ContactRishiDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any
  ) {
      this.form = this.fb.group({
        email: ['', [Validators.required, Validators.email]],
        phone: [
          '',
          [Validators.required, Validators.pattern(/^\+?[0-9]{10,15}$/)]
        ],
        fullName: [
          '',
          [
            Validators.required,
            Validators.pattern(/^[A-Za-z]+(\s+[A-Za-z]+)+$/)
          ]
        ]
      });
    this.item = data;
  }
  ngOnInit() {
    //this.error = 'Error has occured, please try again';
    //this.message = 'Thank you, you will receive a message soon.';
    this.error = '';
    this.message = '';
    this.disabled = false;
  }
  close() {
    this.dialogRef.close();
  }
  submit() {
    this.error = '';
    this.message = '';
    if (this.form.valid) {
      this.disabled = true;
      this.message = 'Submitting, please wait…';
      //this.dialogRef.close(this.form.value);
      try {
        this.cs.request('/public/enquire', 'post', {id:this.item.Id, Email:this.form.value["email"], Phone:this.form.value["phone"], FullName:this.form.value["fullName"]}).then((res: any) => {
        if (res.Status == 200) {
          this.message = res.Message;
        } else if(res.Status == 404) {
          this.message = '';
          this.error = res.Message;
        } else {
          this.message = '';
          this.error = res.Message;
          this.disabled = false;
        }
      });
      }catch(error) {
        this.error = "An error has occurred. Please try again later.";
      };

    }
  }
}